import React from 'react';
import NoAssetsIcon from 'images/noassets.svg';
import NoData2Icon from 'images/nodata2.svg';
import NoNftsIcon from 'images/nonfts.svg';

interface IComp {
  style?: object;
  subTitle?: string;
  isAssets?: boolean;
  isNfts?: boolean;
}

// TODO_R: разделить на 2 компонента один для AssetsTab (NoAssets) и один для NFTsTab (NoNFTs) и один для Queue и History (NoData)
// с переиспользованием составных компонентов.
export const NoData = ({ subTitle, style = {}, isAssets = false, isNfts = false }: IComp) => {
  return (
    <div className="flex flex-col items-center mt-48 sm:mt-88 mb-60 sm:mb-[130px]">
      {isAssets ? (
        <img width={64} height={64} src={NoAssetsIcon} alt="" />
      ) : isNfts ? (
        <img width={64} height={64} src={NoNftsIcon} alt="" />
      ) : (
        <img width={64} height={64} src={NoData2Icon} alt="" />
      )}
      <h3 className="text-m15 mt-16">
        {isAssets ? 'No assets available' : isNfts ? 'No NFTs available' : 'No data available'}
      </h3>
      {subTitle && <p className="text-r14 text-regular mt-8">{subTitle}</p>}
    </div>
  );
};
